export function getMessageDate(message) {
  if (!message) return null;
  const raw = message.createdAt || message.timestamp || message.time;
  if (raw == null || raw === '') return null;
  const date = new Date(raw);
  if (Number.isNaN(date.getTime())) return null;
  return date;
}

export function formatMessageTime(message) {
  const date = getMessageDate(message);
  if (!date) return null;

  const now = new Date();
  const isToday = date.toDateString() === now.toDateString();
  const timeOptions = { hour: '2-digit', minute: '2-digit', hour12: false };

  let label;
  if (isToday) {
    label = date.toLocaleTimeString('zh-TW', timeOptions);
  } else if (date.getFullYear() === now.getFullYear()) {
    label = date.toLocaleString('zh-TW', {
      month: 'numeric',
      day: 'numeric',
      ...timeOptions,
    });
  } else {
    label = date.toLocaleString('zh-TW', {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      ...timeOptions,
    });
  }

  return {
    label,
    dateTime: date.toISOString(),
  };
}
